
/* tslint:disable:no-var-requires */

// NOTE: Removed CoreJS on April 3, 2017. Doesn't seem to provide any strong use
// since we already just target ES5 and it complicates the package quite a bit.
// import "core-js";
import "zone.js/dist/zone";

// TODO: Investigate the annotation inheritance differences between this library
// the eventual semantics of ES ()
import "reflect-metadata/Reflect";

// if (process.env.ENV === "production") {
//   // Production
// } else {
//   // Development
//   Error.stackTraceLimit = Infinity;
//   require("zone.js/dist/long-stack-trace-zone");
// }



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./build-config/polyfills.ts